import getCharts from '../getCharts'
import { SaveExtraData } from '../../constants/api.config'

export default async function SaveExtra(mode, type, jsonData, id = '-1') {
    try {
        const payload = { mode, type, jsonData, id }
        const res = await getCharts(SaveExtraData, payload)
        return res.data
    } catch (error) {
        return error
    }
}
